import { render, staticRenderFns } from "./BerkleyPremium.vue?vue&type=template&id=72772e00"
import script from "./BerkleyPremium.vue?vue&type=script&lang=js"
export * from "./BerkleyPremium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports